import type { ReactNode } from "react";

export function EmptyState({ icon, title, note }: { icon: string; title: string; note?: string }) {
  return (
    <div className="o-empty">
      <span className="ms" aria-hidden="true">{icon}</span>
      <strong>{title}</strong>
      {note && <p>{note}</p>}
    </div>
  );
}

export function SectionCard({ children, style, className = "" }: { children: ReactNode; style?: React.CSSProperties; className?: string }) {
  return (
    <section className={`o-card${className ? ` ${className}` : ""}`} style={style}>
      {children}
    </section>
  );
}

export function Pill({ label, tone = "neutral" }: { label: string; tone?: "neutral" | "success" | "danger" | "warning" | "accent" | "info" | "ink" }) {
  return <span className={`o-pill o-pill--${tone}`}>{label}</span>;
}

export function IconButton({
  icon,
  onClick,
  title,
  tone = "neutral",
  className = "",
}: {
  icon: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string;
  tone?: "neutral" | "danger";
  className?: string;
}) {
  return (
    <button type="button" className={`o-icon-btn${tone === "danger" ? " is-danger" : ""}${className ? ` ${className}` : ""}`} onClick={onClick} title={title} aria-label={title}>
      <span className="ms" aria-hidden="true">{icon}</span>
    </button>
  );
}
